var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33331C14.5315 3.33331 10.8237 4.51526 7.7232 6.71552C4.62273 8.91578 2.28298 12.0255 1.02787 15.6142C-0.227248 19.2029 -0.33564 23.093 0.717697 26.7461C1.77103 30.3991 3.93399 33.6343 6.90713 36.0038C9.88028 38.3733 13.5165 39.7598 17.3125 39.9715C21.1084 40.1832 24.8763 39.2096 28.0945 37.1854C31.3127 35.1612 33.8219 32.1866 35.2749 28.6733C36.7279 25.1601 37.0528 21.282 36.2045 17.576L18.3333 21.6666V3.33331Z",
    fill: "url(#paint0_linear_3438_60998)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3185 14.8236C38.1986 10.6441 35.7534 6.94042 32.3499 4.26852C28.9464 1.59661 24.7682 0.100566 20.4422 0.0048898L20 20L39.3185 14.8236Z",
    fill: "url(#paint1_linear_3438_60998)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3438_60998",
    x1: 18.3333,
    y1: 3.33331,
    x2: 18.3333,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7F741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ECA25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3438_60998",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#189EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3863D2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle.c3daf4227fd03b95e8911a1c1d3bc08d.svg";